/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  circulatingSupplyGetCirculatingSupplyApiV1LedgersLedgerCanisterIdCirculatingSupplyGet,
} from "../../funcs/circulatingSupplyGetCirculatingSupplyApiV1LedgersLedgerCanisterIdCirculatingSupplyGet.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .GetCirculatingSupplyApiV1LedgersLedgerCanisterIdCirculatingSupplyGetRequest$inboundSchema,
};

export const tool$circulatingSupplyGetCirculatingSupplyApiV1LedgersLedgerCanisterIdCirculatingSupplyGet:
  ToolDefinition<typeof args> = {
    name: "circulating-supply-v1",
    description: `Original tool name: get-circulating-supply-ledgers-ledger-canister-id-circulating-supply-get

Get a series of circulating supply values for a ledger

### How is the data for this endpoint gathered?

Circulating supply is calculated by the following formula:

Total Supply = Sum of all mints - Sum of all burns
Circulating Supply = Total Supply - Sum of all balances of accounts to which tokens were minted before swap`,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] =
        await circulatingSupplyGetCirculatingSupplyApiV1LedgersLedgerCanisterIdCirculatingSupplyGet(
          client,
          args.request,
          { fetchOptions: { signal: ctx.signal } },
        ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };